import React from 'react'
import { Field, reduxForm } from 'redux-form'
import  validate  from './../validateReg';
import { withStyles } from '@material-ui/core/styles';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { compose, withHandlers } from 'recompose';

import Button from '@material-ui/core/Button';
import Typography from '@material-ui/core/Typography';

import EmailField from '../EmailField';
import TextField from '../TextField';
import PasswordField from '../PasswordField';
import PhoneField from '../PhoneField';
import ProjectCodeField from '../ProjectCodeField';
import RenderCheckbox from '../AmLeader';
import Dropdown from '../Dropdown';

import { commonStyles } from '../../../styles/styles';


import { MDBContainer, MDBRow, MDBCol, MDBStepper, MDBStep, MDBBtn, MDBCard, MDBCardBody, MDBInput } from "mdbreact";



const ThirdPage = ({ classes, form, pristine, previousPage, submitting, ...props }) => {
  const { handleSubmit, dropdowns } = props;
  return (
    <form className="w-100" onSubmit={handleSubmit}>
    <MDBCol md="12">
    <MDBRow>
      <MDBCol md="6">
      <Field name="maritalStatus" label="Marital Status" component={Dropdown} options={dropdowns.dropdowns.maritalStatus}/>
      </MDBCol>
      <MDBCol md="6">
      <Field name="residenceStatus" label="Residence Status" component={Dropdown} options={dropdowns.dropdowns.residenceStatus}/>
      </MDBCol>
    </MDBRow>
    <MDBRow>
      <MDBCol md="12">
      <Field name="address" label="Home Address" component={TextField}  />
      </MDBCol>
    </MDBRow>
    <MDBRow>
      <MDBCol md="6">
      <Field name="city" label="City" component={TextField}  />
      </MDBCol>
      <MDBCol md="6">
      <Field name="code" label="Postal Code" component={TextField}  />
      </MDBCol>
    </MDBRow>
    <MDBRow>
      <MDBCol md="6">
      <Field name="conProvinceID" label="Province" component={Dropdown}  options={dropdowns.dropdowns.provinces}/>
      </MDBCol>
      <MDBCol md="6">
      <Field name="conCountryID" label="Country" component={Dropdown}  options={dropdowns.dropdowns.countries}/>
      </MDBCol>
    </MDBRow>
    <MDBRow>
      <MDBCol md="6">
      <Field name="telephone" label="Telephone" component={TextField}  />
      </MDBCol>
      <MDBCol md="6">
      <Field name="fax" label="Fax (Optional)" component={TextField}  />
      </MDBCol>

    </MDBRow>
   
    <MDBRow className="mt-2">
            <MDBCol size="6">
              <MDBBtn 
                  right
                  size="md"
                  className='mt-0 mb-2 float-left danger-color-dark'
                  action
                  onClick={previousPage}
                  type="button">
                PREVIOUS
              </MDBBtn>
            </MDBCol>
            <MDBCol size="6">
              <MDBBtn color="success"
                  right
                  size="md"
                  className='ml-3 mr-2 mt-0 mb-2 float-right'
                  action
                  type="submit">
                NEXT
              </MDBBtn>
            </MDBCol>
          </MDBRow>

  </MDBCol>
  </form>
    // <div className={classes.regFormWrapper}>
    //   <h4 className={classes.pageNo}>Page 2 of 5</h4>
    //   <form onSubmit={handleSubmit}>
    //     <div className={`${classes.halfField} ${classes.firstInRow}`}>
    //       <Field name="maritalStatus" label="Marital Status" component={Dropdown} options={dropdowns.dropdowns.maritalStatus}/>
    //     </div>
    //     <div className={classes.halfField}>
    //       <Field name="residenceStatus" label="Residence Status" component={Dropdown} options={dropdowns.dropdowns.residenceStatus}/>
    //     </div>
    //     <div className={`${classes.halfField} ${classes.firstInRow}`}>
    //       <Field name="address" label="Home Address" component={TextField}  />
    //     </div>
    //     <div className={`${classes.halfField}`}>
    //       <Field name="city" label="City" component={TextField}  />
    //     </div>
    //     <div className={`${classes.halfField} ${classes.firstInRow}`}>
    //       <Field name="code" label="Postal Code" component={TextField}  />
    //     </div>
    //     <div className={`${classes.halfField}`}>
    //       <Field name="telephone" label="Telephone" component={TextField}  />
    //     </div>
        
    //     <div className={classes.halfField}>
    //       <Field name="fax" label="Fax (Optional)" component={TextField}  />
    //     </div>
        
    //     <div>
    //       <div className={classes.halfField}>
    //         <button variant="contained"
    //           className={`${classes.defaultButton} ${classes.shortButton}`} type="button"  onClick={previousPage}>Previous</button>
    //       </div>
    //       <div className={classes.halfField}>
    //         <button variant="contained"
    //           className={`${classes.defaultButton} ${classes.shortButton}`} type="submit" >Next</button>
    //       </div>
    //     </div>
    //   </form>
    // </div>
  ) 
}



ThirdPage.propTypes = {
  classes: PropTypes.instanceOf(Object),
  handleSubmit: PropTypes.func,
  login: PropTypes.instanceOf(Object),
  form: PropTypes.instanceOf(Object),
};

const mapStateToProps = state => ({
  form: state.form,
  login: state.loginReducer,
  dropdowns: state.dropdownsReducer,
});
const mapDispatchToProps = dispatch => ({
  registrationRequest: () => dispatch(registrationRequest()),
  loginReset: () => dispatch(loginReset()),
});


const styles = () => ({
  ...commonStyles,
  halfField: {
    display: 'inline-flex',
    width: '49%',
  },
  firstInRow: {
    marginRight: '2%',
  },
  label: {
    color: '#e84848',
  },
  fullField: {
    width: '100%',
  },
  regFormWrapper: {
    maxWidth: '80%',
    margin: '0 auto',
  },
  rowWrapper: {
    display: 'flex',
  },
  noTopLabel: {
    paddingTop: 10,
    paddingLeft: 14,
  },
  pageNo:{
    textAlign: 'center',
    fontFamily: 'Roboto-Bold',

  }
});

export default compose(
  reduxForm({ form: 'registration',
  destroyOnUnmount: false,        // <------ preserve form data
  forceUnregisterOnUnmount: false,  // <------ unregister fields on unmount
  validate
 }),
  connect(mapStateToProps, mapDispatchToProps),
 
  withStyles(styles),
)(ThirdPage);



// WEBPACK FOOTER //
// ./src/Components/Form/RegistrationSteps/ThirdPage.jsx